<template>
  <div class="app ">
    <div class="home">
      <div class="app-container">
        <div class="home-head ">
          <div class="d-flex-between py-40 px-10  fz-28">
            <div class="userinfo" v-if="loginState" @click="userDrawer = true">
              <img src="../../../static/image/add1.png" alt="">
            </div>
            <div class="userinfo" v-else @click="$router.push('/login')">
<!--              <img src="../../assets/logo.png" alt="">-->
              <img src="../../../static/image/add1.png" alt="">
            </div>
            <userinfo :userDrawer="userDrawer" @userinfoClose="userDrawer = false" />
            <div class="language">
              <!-- 中文 -->
              <template v-if="messageList.length === 0">
                <img src="../../../static/image/add2.png" alt="" @click="$router.push('/my/message')" style="width:18px;height:18px;">
              </template>
              <template v-else>
                <el-badge :value="'+' + messageList.length">
                  <img src="../../../static/image/add2.png" alt="" @click="$router.push('/my/message')" style="width:18px;height:18px;">
                </el-badge>
              </template>
              <span style="width:30px;height:100px;margin-left:15px;"></span>
              <el-dropdown @command="languageChange">
                <span class="el-dropdown-link">
                  <img class="flag" :src="languageActive.falg" alt="">
                  {{ languageActive.name }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in languageList" :command="item" :key="item.id">
                    <img class="flag" :src="item.falg" alt="">
                  {{ item.name
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

          </div>
        </div>
        <div class="banner">
          <el-carousel>
            <el-carousel-item v-for="(item, i) in linkList" :key="i">
              <img :src="item.linkPic" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="notice">
          <div class="icon">
            <img src="../../../static/image/notice.png" alt="">
          </div>
          <el-carousel class="flex-1" height="20px" direction="vertical">
            <el-carousel-item v-for="(item, i) in articleList" :key="i">
              <!-- <p @click="$router.push('/my/newsDetail?id=' + item.id)">{{ item.title }}</p> -->
              <Notice :title="item.title" />
            </el-carousel-item>
          </el-carousel>
        </div>
<!--        <div class="video">-->
<!--          <video controls autoplay src="../../../static/image/video.mp4"></video>-->
<!--        </div>-->
        <div class="nav">
          <div class="item" @click="$router.push('/assets/recharge')">
            <div class="icon">
              <img src="../../../static/image/nav1.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.recharge') }}
            </div>
          </div>
          <div class="item" @click="$router.push('/lever/lever')">
<!--            <div class="item" @click="$router.push('/market/second')">-->
            <div class="icon">
              <img src="../../../static/image/nav2.png" alt="">
            </div>
            <div class="title">
              {{ $t('params.transType1') }}
            </div>
          </div>
          <div class="item" @click="$router.push('/my/share')">
            <div class="icon">
              <img src="../../../static/image/nav3.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.invite') }}
            </div>
          </div>
          <div class="item" @click="$router.push('/my/help')">
            <div class="icon">
              <img src="../../../static/image/nav4.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.userinfo_nav9') }}
            </div>
          </div>
          <div class="item" @click="jumpUrl">
            <div class="icon">
              <img src="../../../static/image/nav5.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.userinfo_nav6') }}
            </div>
          </div>
          <div class="item" @click="$router.push('/assets/withdraw')">
            <div class="icon">
              <img src="../../../static/image/nav6.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.withdraw') }}
            </div>
          </div>
          <div class="item" @click="$router.push('/assets/transfer')">
            <div class="icon">
              <img src="../../../static/image/nav7.png" alt="">
            </div>
            <div class="title">
              {{ $t('assets.transfer_title') }}
            </div>
          </div>
          <!-- <div class="item" @click="$router.push('/assets/transfer')">
            <div class="icon">
              <img src="../../../static/image/nav7.png" alt="">
            </div>
            <div class="title">
              Defi
            </div>
          </div> -->
<!--          <div class="item" @click="$router.push('/legal/legal')">-->
<!--            <div class="icon">-->
<!--              <img src="../../../static/image/nav6.png" alt="">-->
<!--            </div>-->
<!--            <div class="title">-->
<!--              {{ $t('assets.legal') }}-->
<!--            </div>-->
<!--          </div>-->
         <div class="item" @click="$router.push('/deposit/index')">
           <div class="icon">
             <img src="../../../static/image/nav9.png" alt="">
           </div>
           <div class="title">
             {{ $t('assets.deposit_title') }}
           </div>
         </div>
<!--          <div class="item" @click="$router.push('/ieo/index')">-->
<!--            <div class="icon">-->
<!--              <img src="../../../static/image/nav8.png" alt="">-->
<!--            </div>-->
<!--            <div class="title">-->
<!--              {{ $t('assets.ieo') }}-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="divider-20"></div>
      <div class="">
        <!-- <div class="real-time-msg scroll-x text-center py-40"> -->
        <div class="real-time-msg  text-center py-40">

          <div class="swiper-container swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide partner-item" v-for="(item, i) in marketList">
                <div class="item">
                  <div class="label">
                    {{ item.title }}/USDT
                    <div class="rate" :class="[item.riseRate < 0 ? 'color-theme-red' : 'color-theme-green']">
                      {{ item.riseRate.toFixed(2) }}%
                    </div>
                  </div>
                  <div class="value fz-18 font-weight-bold"
                    :class="[item.riseRate < 0 ? 'color-theme-red' : 'color-theme-green']">
                    <span>{{ item.last }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="divider-20"></div>
      <div class="">
        <div class="home-list" v-if="marketList.length > 0">
          <div class="title">
            {{ $t('home.increase') }}
          </div>
          <el-table class="app-container" :data="marketList" style="width: 100%" @row-click="detailMarket"
            :default-sort="{ prop: 'riseRate', order: 'descending' }">
            <el-table-column prop="title" :label="$t('home.table_name')">
              <template slot-scope="scope">
                <span class="tit">{{ scope.row.title }}</span><span class="unit">/USDT</span>
              </template>
            </el-table-column>
            <el-table-column prop="last" :label="$t('home.table_lastPrice')" :formatter="toFixed4"></el-table-column>
            <el-table-column prop="riseRate" :label="$t('home.table_increase')" width="90px">
              <template slot-scope="scope">
                <div class="rate" :class="[scope.row.riseRate > 0 ? 'bg-theme-green' : 'bg-theme-red']">
                  {{ scope.row.riseRate }} %
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>

      <Footer :path="'/home'" />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import userinfo from "./components/userinfo.vue";
import Notice from "./components/notice";
import { getBitFavoriteList, getDataList } from "@/api/bit"
import { Loading } from "element-ui";
import { getToken } from "@/utils/auth";
import {dataDomain, getArticleList, getLinkList, serviceUrl} from "@/api/global";

import Swiper from 'swiper'
import "swiper/css/swiper.css";
import {getMessageList} from "@/api/login";

export default {
  components: {
    Footer,
    userinfo,
    Notice,
  },
  data() {
    return {
      serviceUrls: serviceUrl,
      loginState: false,
      loading: false,
      userDrawer: false,
      marketList: [],
      articleList: [],
      messageList: [],
      linkList: [],
      favoriteList: [],
      languageActive: {},
      languageList: [
        // {
        //   id: 0,
        //   abbr: 'zh',
        //   name: "简体中文",
        // },
        {
          id: 1,
          falg: require('/static/flags/China.jpg'),
          abbr: 'tc',
          name: "繁体中文",
        },
        {
          id: 2,
          falg: require('/static/flags/United States.png'),
          abbr: 'en',
          name: "English",
        }, {
          id: 3,
          falg: require('/static/flags/Japan.png'),
          abbr: 'jp',
          name: "日本語",
        }, {
          id: 4,
          falg: require('/static/flags/Korea.png'),
          abbr: 'ko',
          name: "한국어",
        }, {
          id: 5,
          falg: require('/static/flags/Germany.png'),
          abbr: 'de',
          name: "Deutsch",
        }, {
          id: 6,
          abbr: 'es',
          falg: require('/static/flags/Spain.png'),
          name: "Español",
        }, {
          id: 7,
          abbr: 'fr',
          falg: require('/static/flags/France.png'),
          name: "Français",
        }, {
          id: 8,
          abbr: 'pt',
          falg: require('/static/flags/Portugal.png'),
          name: "Portugal",
        },
      ],
      socket: null,
    };
  },
  computed: {},
  created() {
    console.log(window.localStorage.getItem("lang"));
    for (var i = 0; i < this.languageList.length; i++) {
      if (window.localStorage.getItem("lang") === this.languageList[i].abbr) {
        this.languageActive = this.languageList[i]
      }
    }
    let token = getToken()
    if (token) {
      this.loginState = true
    }
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      var mySwiper = new Swiper('.swiper-container', {
        speed: 8000,
        autoplay: {
          delay: 0,
        },
        freeMode: true,
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true//修改swiper的父元素时，自动初始化swiper
      })
    });
  },
  destroyed() {
    this.socket.close()
  },
  methods: {
    jumpUrl() {
      window.location.href = this.serviceUrls
    },
    getList() {
      let _this = this
      _this.loadingInstance = Loading.service({ fullscreen: true });
      getDataList().then(response => {
        _this.marketList = JSON.parse(response.Data)
        if (_this.loginState) {
          getBitFavoriteList().then(response => {
            let favoriteList = response.Data.content
            _this.favoriteList = []
            for (let i = 0; i < _this.marketList.length; i++) {
              for (let j = 0; j < favoriteList.length; j++) {
                if (_this.marketList[i].id == favoriteList[j].bit_id) {
                  _this.favoriteList.push(_this.marketList[i])
                }
              }
            }
          })
          getMessageList({state: 0}).then(response => {
            _this.messageList = response.Data.content;
          })
        }
        getArticleList({ typeId: 3 }).then(response => {
          _this.articleList = response.Data.content
        })
        getLinkList({ typeId: 1 }).then(response => {
          _this.linkList = response.Data.content
        })
        _this.getCurrency()
        _this.loadingInstance.close()
      })
    },
    getCurrency() {
      let _this = this;
      this.socket = new WebSocket(dataDomain);
      this.socket.onopen = function (e) {
        console.log("online ---  ws is open");
      }
      this.socket.onclose = function (e) {
        console.log("offline ---  ws is close");
      }
      this.socket.onmessage = function (evt) {
        let data = JSON.parse(evt.data)
        _this.marketList = data
      }
    },
    toFixed4(row, column) {
      if (row[column.property]) {
        return parseFloat(row[column.property]).toFixed(4)
      }
    },
    detailMarket(row, event, column) {
      let id = row.id
      this.$router.push("/market/second?id=" + id)
    },
    languageChange(item) {
      this.languageActive = item;
      this.$i18n.locale = item.abbr;
      window.localStorage.setItem(
        "lang",
        this.$i18n.locale
      );
    },
  }
}
</script>
<style lang="less" scoped>
.app {
  padding-top: 0;

  .home {
    .home-head {
      background-color: #fff;

      .userinfo {
        font-size: 0;

        img {
          height: 50px;
          border-radius: 50%;
        }
      }
      .language {
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
    }

    .banner {
      background-color: #fff;

      /deep/ .el-carousel__container {
        height: 320px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
.video {
  video {
    width: 100%;
  }
}
    .notice {
      background-color: #fff;
      padding: 30px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e2e7eb;

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 30px;
        }
      }

      p {
        padding-left: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 26px;
      }

    }




    .nav {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 0;

      .item {
        width: 25%;
        text-align: center;
        padding: 20px 0;

        .icon {
          img {
            width: 42px;
          }
        }

        .title {
          font-size: 24px;
        }
      }
    }

    .real-time-msg {
      .item {
        display: inline-block;
        padding: 0 20px;

      }

      .rate {
        font-size: 24px;
      }

      .value {
        font-size: 36px;
        padding: 5px 0;
      }

      .label {
        font-size: 24px;
        display: flex;
        align-items: center;
      }
    }

    .home-list {

      .title {
        padding: 20px 40px;
        border-bottom: 1px solid #e2e7eb;
      }

      /deep/ .el-table {
        padding-bottom: 200px;

        .cell {
          line-height: 2.5;
          white-space: nowrap;
          overflow: hidden;
        }

        th {
          font-weight: normal !important;
          // font-size: 12px;
          // font-size: 28px;
        }

        td {
          color: #000;
          font-size: 28px;
        }

        .caret-wrapper {
          width: 24px;
          height: 34px;
        }

        .sort-caret {
          border-width: 8px;

          &.ascending {
            top: 0;
            left: 7px;

          }

          &.descending {
            bottom: 0;
            left: 7px;
          }
        }
      }

      .tit {
        font-weight: bold;
        font-size: 32px;
      }

      .unit {
        font-size: 24px;
        color: #666;
      }

      .rate {
        color: #FFF;
        font-size: 24px;
        text-align: center;
        border-radius: 5px;
      }
    }
  }

}
.el-dropdown-menu .el-dropdown-menu__item {
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: bottom;
  }
}
</style>
